import React, { useEffect } from 'react';
import styled from 'styled-components';
import Button from "./Button";
import ReactDOM from "react-dom";
import { dasherize } from "../helpers/dasherize";
// 'HelloProps' describes the shape of props.
// State is never set so we use the '{}' type.
export const ModalComponent = (props) => {
    const windowHelper = window;
    useEffect(() => {
        windowHelper._uxa && windowHelper._uxa.push(['trackPageview', window.location.pathname + `?modal=${dasherize(props.title)}`]);
    }, []);
    return (React.createElement(ModalContainer, { showing: props.showing, className: 'tailwind' },
        React.createElement(ModalContent, null,
            React.createElement(CloseImage, { onClick: props.onHide, src: 'https://cdn.shopify.com/s/files/1/2074/9385/files/Close_X_083b63ff-bd9e-43a7-8da7-036ec399c5dc.png?v=1634048762' }),
            typeof props.title === 'string' ? React.createElement(Title, null, props.title) : props.title,
            typeof props.body === 'string' ? React.createElement(Description, null, props.body) : props.body,
            props.submitText !== '' ? React.createElement(Button, { noMargin: true, onClick: props.onSubmit }, props.submitText) : null)));
};
export class Modal {
    static open(title, description, submitText = 'OK', onSubmit, onHide) {
        const onClose = () => {
            if (onHide) {
                onHide();
            }
            Modal.close();
        };
        const onSuccess = () => {
            if (onSubmit) {
                onSubmit();
            }
            Modal.close();
        };
        Modal._modal = document.createElement('div');
        document.body.append(Modal._modal);
        ReactDOM.render(React.createElement(ModalComponent, { showing: true, title: title, body: description, submitText: submitText, onHide: onClose, onSubmit: onSuccess }), Modal._modal);
    }
    static close() {
        Modal._modal.remove();
    }
}
const ModalContainer = styled.div `
  position: fixed;
  top: ${(props) => props.showing ? 0 : '-200%'};
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(102, 102, 102, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100000;
`;
const ModalContent = styled.div `
  padding: 20px;
  background: #FFFFFF;
  position: relative;
  margin: 20px;
`;
const Title = styled.div `
    font-family: KapraNeue, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 35px;
    text-align: center;
    letter-spacing: 0.9625px;
    text-transform: uppercase;
    color: #393D40;
`;
const Description = styled.div `
  font-family: AvenirNext, Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.583333px;
  color: #393D40;
  margin-top: 30px;
  margin-bottom: 30px;
`;
const CloseImage = styled.img `
    width: 22px;
    height: 22px;
    position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
`;
